import { isArray } from 'lodash';

import { isStateActive } from './orders';

export const serializeAttachment = attachment => ({
  id: attachment.id?.toString(),
  name: attachment.name || attachment.title,
  size: attachment.size,
  url: attachment.url,
  type: attachment.type,
});

export const serializeAttachments = attachments => {
  if (!isArray(attachments) || attachments.length < 1) return [];

  return attachments.map(at => serializeAttachment(at));
};

export const serializeAttachmentsToMap = attachments => {
  if (!isArray(attachments) || attachments.length < 1) return null;

  return attachments.reduce((acc, at) => {
    const attachment = serializeAttachment(at);
    return attachment.id
      ? {
          [attachment.id]: attachment,
          ...acc,
        }
      : acc;
  }, {});
};

export const groupAttachmentsByOrderID = orders => {
  if (!Array.isArray(orders) || orders.length < 1) return [];

  let hasAttachments = false;

  const handledAttachments = orders.reduce(
    (
      prev,
      {
        id,
        state,
        attachments = [],
        custom_attachments: customAttachments = [],
      }
    ) => {
      const active = isStateActive(state);
      if (!hasAttachments) hasAttachments = !!attachments.length;

      if (attachments || active) {
        return [
          ...prev,
          {
            id,
            attachments: [...attachments, ...customAttachments],
            active,
          },
        ];
      }

      return prev;
    },
    []
  );

  return (hasAttachments && handledAttachments) || [];
};
